module.exports = __webpack_public_path__ + "static/media/fast_smart_fun.4718658c.svg";